import React from "react";
import { Outlet } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext"; // Import language context
import HeaderSection from "../components/ui/HeaderSection";
import Container from "../components/ui/Container";
import communityHero from "../assets/komet-assets/communityHeroImg.svg";

const CommunityHome = () => {
    const { language } = useLanguage(); // Get selected language

    const content = {
        tagline: {
            en: "#Speak - Discuss - Learn",
            ar: "#تحدّث ـ ناقش ـ وتعلم",
            de: "#Sprechen - Diskutieren - Lernen",
        },
        headline: {
            en: "Get Ready for Life in a German-Speaking Environment",
            ar: "استعد للحياة في بيئة ناطقة بالألمانية",
            de: "Mach dich bereit für das Leben in einer deutschsprachigen Umgebung",
        },
        description: {
            en: "The Kommet Student Forum – Where your real journey to mastering German begins!",
            ar: "منتدى الطلبة الخاص بـ Kommet – حيث تبدأ رحلتك الحقيقية نحو إتقان اللغة الألمانية!",
            de: "Das Kommet-Studentenforum – Wo deine echte Reise zum Deutschlernen beginnt!",
        },
    };

    return (
        <>
            <div className="smooth clr-text-primary posisitve-nav-padding-top">
                <Container className="py-10 pb-10 space-y-0">
                    <div className="w-full rounded-2xl py-10 md:py-2 px-10 md:px-0 smooth relative overflow-hidden z-10 flex md:flex-row-reverse flex-col h-full space-y-10 md:space-y-0">
                        <div className="basis-full md:basis-1/2 z-10 flex-center-both">
                            <div className="flex md:items-start justify-center flex-col space-y-10 md:space-y-0">
                                <h1
                                    className={`leading-[1] relative text-center ${
                                        language === "ar" ? "md:text-right" : "md:text-left"
                                    }`}
                                >
                                    <div className="flex gap-4 items-center">
                                        <span className="text-xl md:text-2xl text-yellow-500">
                                            {content.tagline[language]}
                                        </span>
                                    </div>
                                    <br />
                                    <span className="text-germanRed-700 dark:text-[#f7f7f7] smooth text-[3rem]">
                                        {content.headline[language]
                                            .split(" ")
                                            .slice(0, 3)
                                            .join(" ")}
                                        <br />
                                        {content.headline[language].split(" ").slice(3).join(" ")}
                                    </span>
                                </h1>
                                <p
                                    className={`text-center ${
                                        language === "ar" ? "md:text-right" : "md:text-left"
                                    } text-xl text-gray-500 smooth w-full pt-5 md:pt-10 lg:w-[70%]`}
                                >
                                    {content.description[language]}
                                </p>
                            </div>
                        </div>
                        <div className="basis-full md:basis-1/2 z-10 h-full flex-center-both pt-10 md:pt-0">
                            <div className="flex-center-both max-w-2xl px-10 sm:px-20">
                                <img
                                    src={communityHero}
                                    alt="communityHero"
                                    className="w-full rounded-full"
                                />
                            </div>
                        </div>
                    </div>
                </Container>
                <div className="w-full relative clr-text-primary smooth">
                    <Outlet />
                </div>
                <Container></Container>
            </div>
        </>
    );
};

export default CommunityHome;
